import { Grid } from '@material-ui/core';
import moment from 'moment-timezone';
import React from 'react';

import { CalendarQuickSelector } from '~/src/dash/components/calendar/calendar-quick-selector';
import { CalendarWrapper, IFocusedInput } from '~/src/dash/components/calendar/calendar-wrapper';
import { ICalendarQuickSelectorOptions } from '~/src/dash/utils/calendar';

interface IProps {
  // Current start and end date for the calendar
  startDate: moment.Moment;
  endDate: moment.Moment;

  // Upcoming start and end date selected
  calStartDate: moment.Moment;
  calEndDate: moment.Moment;

  // ID required for Date Range picker
  startDateID: string;
  endDateID: string;

  // Current range selected
  rangeSelected: string;

  // custom settings
  numberOfMonths?: number;
  hideCalendarInfo?: boolean;
  withPortal?: boolean;

  handleRangeSelected: (
    rangeSelected: string,
    isCompareCalendar: boolean,
    applied?: boolean,
  ) => void;
  handleCalendarDateChange: (start: moment.Moment, end: moment.Moment, isCustom: boolean) => void;
  handleDateRangeChange: (
    start: moment.Moment,
    end: moment.Moment,
    isCompareCalendar: boolean,
  ) => void;
  quickSelectorOptions: ICalendarQuickSelectorOptions[];
  quickSelectorCustomOptions: ICalendarQuickSelectorOptions[];
  isDayHighlighted: (day: moment.Moment) => boolean;

  // True if calendar is compared off another
  isCompareCalendar: boolean;
  focusedInput: IFocusedInput;
  handleFocusedInputChange: (focusedInput: IFocusedInput) => void;
  dateFormat: string;
  timezone: string;
  excludeToday?: boolean;
  minDate?: moment.Moment;
  trackOnClose?: (final: {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
  }) => void;

  // calendar orientation
  anchorDirection?: 'left' | 'right' | undefined;
}

export class Calendar extends React.Component<IProps> {
  render() {
    const {
      startDate,
      endDate,
      calStartDate,
      calEndDate,
      startDateID,
      endDateID,
      minDate,
      dateFormat,
      handleCalendarDateChange,
      handleDateRangeChange,
      quickSelectorOptions,
      quickSelectorCustomOptions,
      isDayHighlighted,
      isCompareCalendar,
      focusedInput,
      handleFocusedInputChange,
      handleRangeSelected,
      rangeSelected,
      timezone,
      trackOnClose,
      anchorDirection,
      numberOfMonths,
      hideCalendarInfo,
      withPortal,
    } = this.props;

    return (
      <Grid item>
        <CalendarWrapper
          key={1}
          startDate={startDate}
          endDate={endDate}
          calStartDate={calStartDate}
          calEndDate={calEndDate}
          startDateID={startDateID}
          endDateID={endDateID}
          handleCalendarDateChange={handleCalendarDateChange}
          calendarInfoPosition='after'
          focusedInput={focusedInput}
          handleFocusedInputChange={handleFocusedInputChange}
          isDayHighlighted={isDayHighlighted}
          isCompareCalendar={isCompareCalendar}
          stateDateWrapper={(date: any) => date}
          dateFormat={dateFormat}
          timezone={timezone}
          trackOnClose={trackOnClose}
          excludeToday
          minDate={minDate}
          anchorDirection={anchorDirection || undefined}
          numberOfMonths={numberOfMonths}
          withPortal={withPortal}
          renderCalendarInfo={() => {
            if (hideCalendarInfo) {
              return <></>;
            }
            return (
              <CalendarQuickSelector
                startDate={startDate}
                endDate={endDate}
                calStartDate={calStartDate}
                calEndDate={calEndDate}
                handleRangeSelected={handleRangeSelected}
                rangeSelected={rangeSelected}
                handleCalendarDateChange={handleCalendarDateChange}
                handleDateRangeChange={handleDateRangeChange}
                handleFocusedInputChange={handleFocusedInputChange}
                isCompareCalendar={isCompareCalendar}
                calendarQuickSelectorOptions={quickSelectorOptions}
                calendarQuickSelectorCustomOptions={quickSelectorCustomOptions}
              />
            );
          }}
        />
      </Grid>
    );
  }
}
